import type { PlayerProfile, SaveProfileRequest } from '@swiss-magic/shared-types';
import { ApiError, del, get, postFormData, put } from './core';

export async function getProfile(): Promise<PlayerProfile | null> {
  try {
    return await get<PlayerProfile>('/profile');
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

export function saveProfile(data: SaveProfileRequest): Promise<PlayerProfile> {
  return put<PlayerProfile>('/profile', data);
}

export function uploadProfileAvatar(file: File): Promise<PlayerProfile> {
  const form = new FormData();
  form.append('file', file);
  return postFormData<PlayerProfile>('/profile/avatar', form);
}

export function deleteProfileAvatar(): Promise<PlayerProfile> {
  return del<PlayerProfile>('/profile/avatar');
}
